/**
 * Slider Animations using GSAP & Swiper
 */

export class SwiperAnimations {
  constructor() {
    this.init();
  }

  /**
   * Initialize animations
   */
  init() {
    if (typeof Swiper === "undefined" || typeof gsap === "undefined") {
      console.warn("Swiper or GSAP not loaded");
      return;
    }

    this.homeReviews();
    this.insideReviews();
    this.featuredBlogSlider();
  }

  featuredBlogSlider() {
    const section = document.querySelector(".wps-featured-blog");
    if (!section) return;

    new Swiper(".blogSwiper", {
      slidesPerView: 1,
      speed: 600,
      effect: "fade",
      loop: true,
      fadeEffect: {
        crossFade: true,
      },

      navigation: {
        nextEl: ".next",
        prevEl: ".prev",
      },
    });
  }

  homeReviews() {
    const section = document.querySelector(".wps-homepage-reviews");

    if (section) {
      const slider = section.querySelector(".reviews__slider");
      const btnPrev = section.querySelector(".btn--prev");
      const btnNext = section.querySelector(".btn--next");
      const container = section.querySelector(".overlay");

      function calcLeftDistance() {
        const left = slider.getBoundingClientRect().left - 40;

        gsap.set(container, {
          width: left,
        });
      }
      calcLeftDistance();

      window.addEventListener("resize", calcLeftDistance);

      const swiper = new Swiper(slider, {
        slidesPerView: "auto",
        spaceBetween: 40,
        centeredSlides: false,
        loop: true,
        speed: 800,

        navigation: {
          prevEl: btnPrev,
          nextEl: btnNext,
        },

        // breakpoints: {
        //   569: {
        //     slidesPerView: 1.25,
        //   },
        //   769: {
        //     slidesPerView: 2,
        //   },
        //   993: {
        //     slidesPerView: 1.25,
        //   },
        // },
      });
    }
  }

  insideReviews() {
    const section = document.querySelector(
      ".wps-insidepage-user-reviews-masonry",
    );
    if (!section) return;

    const swiperEl = section.querySelector(
      ".wps-insidepage-user-reviews-masonry__slider",
    );
    const slides = swiperEl.querySelectorAll(".swiper-slide");
    if (slides.length === 1) return;

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 40,
      speed: 0,
      loop: true,

      navigation: {
        nextEl: section.querySelector(".btn--next"),
        prevEl: section.querySelector(".btn--prev"),
      },

      on: {
        init: function () {
          animateSlide(this.slides[this.activeIndex]);
        },

        slideChange: function () {
          animateSlide(this.slides[this.activeIndex]);
        },
      },
    });

    function animateSlide(slide) {
      const left = slide.querySelector(".slide__left");
      const right = slide.querySelector(".slide__content");

      gsap.set([left, right], { opacity: 0, y: 30 });

      gsap
        .timeline()
        .to(slide, {
          opacity: 1,
          duration: 0.3,
          ease: "power2.out",
        })
        .to(
          left,
          {
            opacity: 1,
            y: 0,
            duration: 0.5,
            ease: "power2.out",
          },
          "<",
        )
        .to(
          right,
          {
            opacity: 1,
            y: 0,
            duration: 0.6,
            ease: "power2.out",
          },
          "-=0.3",
        );
    }
  }
}
